import { render } from "./LianLianPayView.vue?vue&type=template&id=67b61b0a&scoped=true"
import script from "./LianLianPayView.vue?vue&type=script&lang=js"
export * from "./LianLianPayView.vue?vue&type=script&lang=js"

import "./LianLianPayView.vue?vue&type=style&index=0&id=67b61b0a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b61b0a"]])

export default __exports__